interface StatCardProps {
  title: string
  value: string | number
  subtitle?: string
  trend?: "up" | "down" | "neutral"
  icon?: React.ReactNode
}

export function StatCard({ title, value, subtitle, trend, icon }: StatCardProps) {
  const trendColor =
    trend === "up"
      ? "text-forest-700"
      : trend === "down"
        ? "text-red-600"
        : "text-ink/50"

  return (
    <div className="flex flex-col rounded-[10px] border border-gold-500 bg-white p-5 transition-all duration-200 hover:border-forest-500 hover:shadow-md">
      <div className="flex items-start justify-between">
        <span className="text-sm font-medium text-ink/60">{title}</span>
        {icon && (
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-forest-950/5 text-forest-950">
            {icon}
          </span>
        )}
      </div>
      <span className="mt-3 font-display text-[32px] font-bold leading-none text-ink">
        {value}
      </span>
      {subtitle && (
        <span className={`mt-2 text-sm ${trendColor}`}>
          {subtitle}
        </span>
      )}
    </div>
  )
}
